import { Media } from '@/styles';
import styled from '@emotion/styled';
import Base, { RoundedButtonProps } from './Base';

const Community = ({ active, ...props }: RoundedButtonProps): JSX.Element => {
  return (
    <Base {...props}>
      {active ? (
        <Svg viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 0C6.492 0 0 6.492 0 14.5C0 32.5 24 36 24 36V29H25.5C33.508 29 40 22.508 40 14.5C40 6.492 33.508 0 25.5 0H14.5ZM20 17.5C20.663 17.5 21.2989 17.2366 21.7678 16.7678C22.2366 16.2989 22.5 15.663 22.5 15C22.5 14.337 22.2366 13.7011 21.7678 13.2322C21.2989 12.7634 20.663 12.5 20 12.5C19.337 12.5 18.7011 12.7634 18.2322 13.2322C17.7634 13.7011 17.5 14.337 17.5 15C17.5 15.663 17.7634 16.2989 18.2322 16.7678C18.7011 17.2366 19.337 17.5 20 17.5ZM30.5 15C30.5 15.663 30.2366 16.2989 29.7678 16.7678C29.2989 17.2366 28.663 17.5 28 17.5C27.337 17.5 26.7011 17.2366 26.2322 16.7678C25.7634 16.2989 25.5 15.663 25.5 15C25.5 14.337 25.7634 13.7011 26.2322 13.2322C26.7011 12.7634 27.337 12.5 28 12.5C28.663 12.5 29.2989 12.7634 29.7678 13.2322C30.2366 13.7011 30.5 14.337 30.5 15ZM12 17.5C12.663 17.5 13.2989 17.2366 13.7678 16.7678C14.2366 16.2989 14.5 15.663 14.5 15C14.5 14.337 14.2366 13.7011 13.7678 13.2322C13.2989 12.7634 12.663 12.5 12 12.5C11.337 12.5 10.7011 12.7634 10.2322 13.2322C9.76339 13.7011 9.5 14.337 9.5 15C9.5 15.663 9.76339 16.2989 10.2322 16.7678C10.7011 17.2366 11.337 17.5 12 17.5Z"
            fill="#4859A4"
          />
        </Svg>
      ) : (
        <Svg viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 0C6.492 0 0 6.492 0 14.5C0 32.5 24 36 24 36V29H25.5C33.508 29 40 22.508 40 14.5C40 6.492 33.508 0 25.5 0H14.5ZM20 17.5C20.663 17.5 21.2989 17.2366 21.7678 16.7678C22.2366 16.2989 22.5 15.663 22.5 15C22.5 14.337 22.2366 13.7011 21.7678 13.2322C21.2989 12.7634 20.663 12.5 20 12.5C19.337 12.5 18.7011 12.7634 18.2322 13.2322C17.7634 13.7011 17.5 14.337 17.5 15C17.5 15.663 17.7634 16.2989 18.2322 16.7678C18.7011 17.2366 19.337 17.5 20 17.5ZM30.5 15C30.5 15.663 30.2366 16.2989 29.7678 16.7678C29.2989 17.2366 28.663 17.5 28 17.5C27.337 17.5 26.7011 17.2366 26.2322 16.7678C25.7634 16.2989 25.5 15.663 25.5 15C25.5 14.337 25.7634 13.7011 26.2322 13.2322C26.7011 12.7634 27.337 12.5 28 12.5C28.663 12.5 29.2989 12.7634 29.7678 13.2322C30.2366 13.7011 30.5 14.337 30.5 15ZM12 17.5C12.663 17.5 13.2989 17.2366 13.7678 16.7678C14.2366 16.2989 14.5 15.663 14.5 15C14.5 14.337 14.2366 13.7011 13.7678 13.2322C13.2989 12.7634 12.663 12.5 12 12.5C11.337 12.5 10.7011 12.7634 10.2322 13.2322C9.76339 13.7011 9.5 14.337 9.5 15C9.5 15.663 9.76339 16.2989 10.2322 16.7678C10.7011 17.2366 11.337 17.5 12 17.5Z"
            fill="#BEC6E4"
          />
        </Svg>
      )}
    </Base>
  );
};

const Svg = styled.svg`
  height: auto;
  @media ${Media.sm} {
    width: 1.5rem;
  }
  @media ${Media.md} {
    width: 2.5rem;
  }
  @media ${Media.lg} {
    width: 2.5rem;
  }
`;

Community.defaultProps = {
  active: false,
};

export default Community;
